import { ServerConfig } from "@/config/config";
import { IParticipantInfoResponse } from "@/plugins/billit/utils/participant-info";
import { Axios } from "@/utils/axios";
import Vue from "vue";



export const BillitService = new Vue({
	computed: {
		url():string {
			return ServerConfig.host + "/billit";
		}
	},
	methods: {
		async getParticipantInfo(vat:string):Promise<IParticipantInfoResponse> {
			let response = await Axios.get(`${this.url}/participant-info/${encodeURIComponent(vat)}`);
			return response.data;
		},
		async sendSale(saleID:number, invoiceType:string, po:string, department:string, files:File[], endpointID?:string) {
			let body = new FormData();
			body.append("InvoiceType", invoiceType);
			body.append("PO", po);
			body.append("Department", department || "");
			if (endpointID) {
				body.append("EndpointID", endpointID);
			}

			body.append("FileCount", `${files.length}`);
			for (let i = 0; i < files.length;i++) {
				body.append(`file-${i}`, files[i], files[i].name);
			}

			await Axios.post(`${this.url}/send-sale/${saleID}`, body);
		}
	}
});